import React from 'react';

const Image = ({ src, alt, ...props }: any) => {
    // eslint-disable-next-line @next/next/no-img-element
    return <img src={src} alt={alt} {...props} />;
};

export default Image;
export { Image };
